
export default {
  maps: {
    pageTitle: 'ORS Maps',
    Places: 'Locais',
    isochrones: 'Isócronos',
    placeNameRequired: 'Nome do local requerido',
    altitude: 'Variação de altitude',
    settings: 'Opções',
    toggleAccessibleMode: 'Ativar/desativar o modo de acessibilidade',
    about: 'Sobre o ORS',
    updateSearch: 'Buscar nessa área',
    updateSearchAfterZoomOrCenterChange: 'Atualizar busca depois que o centro é alterado',
    pageNotFound: 'Página não encontrada. Verifique se a URL não está incompleta ou incorreta'
  }
}
